/**
 * Bridges active WP Period Tab YOA + P7 data mode into non-React save/get helpers.
 * DialogLauncher sets this when the WP needs slice YOA (PL·MULTI or BS whitelist);
 * cleared on close / for single-mode BS.
 *
 * @see docs/multi-year-phases/multi-year-phase7-wp-yoa-persistence.md §2.4
 */
import type {WpDataMode} from '@/utils/auditPeriodWpMulti';

let activeYearOfAssessment: string | null = null;
let activeWpCode: string | null = null;
let activeWpDataMode: WpDataMode = 'single';
/** FsAdjustment MULTI 会话标记（DialogLauncher 按 periods/spanType 派生；非白名单 BS 也为 MULTI） */
let activeSpanType: 'SINGLE' | 'MULTI' = 'SINGLE';
/** PL TotalSingle preview — block saveOrUpdate from writing YOA buckets */
let activePlTotalView = false;

export function setActiveWpPeriodContext(args: {
  code?: string | null;
  yearOfAssessment?: string | null;
  dataMode?: WpDataMode | null;
  spanType?: string | null;
  plTotalView?: boolean;
}) {
  activeWpCode = args.code ? String(args.code).trim().toUpperCase() : null;
  activeWpDataMode = args.dataMode || 'single';
  activeSpanType = String(args.spanType || '').toUpperCase() === 'MULTI' ? 'MULTI' : 'SINGLE';
  activePlTotalView = !!args.plTotalView;
  const trimmed = typeof args.yearOfAssessment === 'string' ? args.yearOfAssessment.trim() : '';
  const needsYoa = activeWpDataMode === 'pl-slice' || activeWpDataMode === 'bs-multi';
  activeYearOfAssessment = needsYoa && trimmed ? trimmed : null;
}

/** @deprecated Prefer setActiveWpPeriodContext */
export function setActiveWpYearOfAssessment(yoa: string | null | undefined) {
  const trimmed = typeof yoa === 'string' ? yoa.trim() : '';
  activeYearOfAssessment = trimmed || null;
}

export function getActiveWpYearOfAssessment(): string | null {
  return activeYearOfAssessment;
}

export function getActiveWpCode(): string | null {
  return activeWpCode;
}

export function getActiveWpDataMode(): WpDataMode {
  return activeWpDataMode;
}

/** FsAdjustment 当前 WP 会话是否 MULTI（DialogLauncher 派生，含非白名单 BS）。 */
export function getActiveWpSpanType(): 'SINGLE' | 'MULTI' {
  return activeSpanType;
}

export function isActiveWpPlTotalView(): boolean {
  return activePlTotalView;
}

export function clearActiveWpYearOfAssessment() {
  activeYearOfAssessment = null;
  activeWpCode = null;
  activeWpDataMode = 'single';
  activeSpanType = 'SINGLE';
  activePlTotalView = false;
}

export function clearActiveWpPeriodContext() {
  clearActiveWpYearOfAssessment();
}
